import { MutationHookOptions } from '@apollo/client'
import { Exact, UpdateGroupMutation, UpdateGroup__Input, useUpdateGroupMutation } from '../../../../../graphql'
import { useShowSuccess, useShowError } from 'hooks/useToast'

export default function useUpdateGroupHandler( options?: MutationHookOptions<UpdateGroupMutation, Exact<{ input: UpdateGroup__Input }>> ) {
	const [ updateGroup ] = useUpdateGroupMutation( options )
	const showSuccess = useShowSuccess()
	const showError = useShowError()

	return async( id: number, name?: string, spendingLimit?: string ) => {
		const result = await updateGroup( { variables: {
			input: {
				groupId: id,
				name,
				spendingLimit: spendingLimit ? parseFloat( spendingLimit ) : null
			}
		} } )

		const { success, message } = result.data?.updateGroup ?? {}

		if ( success ) {
			showSuccess( `updateGroupSuccess${Date.now()}`, message ?? 'Successfully updated group!' )
		} else {
			showError( `updateGroupError${Date.now()}`, message ?? 'Sorry, an error occurred' )
		}
	}
}
